import { render, staticRenderFns } from "./player-years-list.vue?vue&type=template&id=4dc0537c&"
import script from "./player-years-list.vue?vue&type=script&lang=js&"
export * from "./player-years-list.vue?vue&type=script&lang=js&"
import style0 from "./player-years-list.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "player-years-list.vue"
export default component.exports